import { store } from '@/store'

export const requestSuccessInterceptor = config => {
  const tokenType = 'Bearer'
  const tokenScope = store.getters.tokenScope
  let token = localStorage.getItem(`${tokenScope}_access_token`)
  if (token && token !== null) {
    config.headers.common['Authorization'] =
     `${tokenType} ${token}`
  }
  return config
}

export const requestErrorInterceptor = error => {
  return Promise.reject(error)
}
